import React from 'react'
import { AlertContextProps } from './types'

export const AlertContext = React.createContext<AlertContextProps | {}>({})
